import { createClient } from 'contentful'

export * from './utils'

export const contentfulClient = createClient({
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
  host:
    process.env.CONTENTFUL_PREVIEW === 'true'
      ? 'preview.contentful.com'
      : 'cdn.contentful.com',
})

export default contentfulClient
